<template>
  <div>
    <az-break-title title="Tabelas e Valores" />

    <div>
      <div class="row mb-3">
        <div class="col col-12 col-md-6">
          <az-input icon="fas fa-search" v-model="search" />
        </div>
        <div class="col col-12 col-md-3 d-flex flex-column">
            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                @click="viewMode = 'A'">
                    Ativos
                </button>
                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                @click="viewMode = 'T'">
                    Todos
                </button>
            </div>
        </div>
        <div class="col col-12 col-md-3 d-flex flex-column">
          <button type="button" class="btn btn-outline-success" @click="incluir ()">Vincular Tabela</button>
        </div>
      </div>
    </div>

    <div v-if="!lista || !lista.length">
      <az-empty-state
        icon="fas fa-search"
        msg="Nenhuma tabela identificada."
        :action="!search ? 'Vincular Tabela' : ''"
        :method="incluir"
      />
    </div>

    

    <div v-if="lista && lista.length">

      <ordenacao-dragn-drop v-model="pode_ordenar" :search="search" />

      <div class="list-group mb-3 az-anime-surgir mb-3">
        <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary"
          :draggable="search || !pode_ordenar ? '.none' : '.list-group-item'">
          <li
            class="list-group-item d-flex justify-content-between hover-bg"
            v-for="(dado, id) in lista"
            :key="id"
          >
            <span>
              <a
                href="#"
                @click.prevent="editar(dado)"
                class="h5 card-link mb-0 mr-3"
              >{{ dado.search }}</a>
            </span>
            <span class="d-flex">
              <div class="mr-3 small" :class="dado.dt_inicio_vigencia > $util.hoje() ? 'text-danger' : 'text-muted'">
                {{ $util.getFormatDate(dado.dt_inicio_vigencia) }}
              </div>
              <div>
                <span class="badge badge-secondary mr-3" v-if="dado.filtros && dado.filtros.length" title="Filtros">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                  {{ dado.filtros.length }}
                </span>
              </div>
              <div v-if="!dado.tabela_versao.fl_moeda_corrente">
                <a href="#" class="card-link mr-3" @click.prevent="listar_cotacoes(dado)"
                  data-toggle="tooltip" data-placement="top" title="Cotação de Moedas da Operadora">
                  <i class="fas fa-dollar-sign"></i>
                </a>
              </div>
              <div v-else class="mr-3 text-muted" data-toggle="tooltip" data-placement="top" title="Tabela de Preço na Moeda Corrente. Sem Cotações.">
                <i class="fas fa-money-bill-alt"></i>
              </div>
              <div>
                <a
                  href="#"
                  class="card-link mr-3"
                  @click.prevent="$util.abrirTabela(dado.tabela_versao)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Itens da Tabela"
                >
                  <i class="fa fa-list" aria-hidden="true"></i>
                </a>
              </div>

              <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'ativo-' + id"
                  v-model="dado.fl_ativo"
                  @change="toggle(dado)"
                />
                <label class="custom-control-label" :for="'ativo-' + id"></label>
              </div>
            </span>
          </li>
        </draggable>
      </div>

      <button type="button" class="btn btn-outline-primary" @click="ver_precos()">
        Ver Preços
      </button>

    </div>

    <!-- Modal da Tabela -->
    <div class="modal fade" id="tabelaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" v-if="item">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Tabela
              {{ item.id_tabela_operadora ? '' : '(Nova)' }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12">
                <az-input 
                  label="Título" 
                  placeholder="Informe o título para tabela na operadora..."
                  :validate="validate"
                  v-model="item.st_titulo" />
              </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input
                        type="select"
                        optionsMode="aql"
                        service="codigo_tabelas.index"
                        optionsData="id_codigo_tabela"
                        label="Código da Tabela"
                        required
                        :validate="validate"
                        v-model="item.id_codigo_tabela"
                    />
                </div>
              
                <div class="col col-12 col-md-3">
                    <az-input 
                        type="date" 
                        label="Início da Vigência" 
                        :validate="validate"
                        required
                        v-model="item.dt_inicio_vigencia" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        type="date" 
                        label="Término da Vigência" 
                        :validate="validate"
                        v-model="item.dt_termino_vigencia" />
                </div>
            </div>

            <div class="row">
              <div class="col col-12" :class="tem_percentual ? 'col-md-9' : ''">
                <az-input
                  type="autocomplete"
                  optionsMode="aql"
                  :optionsSync="false"
                  service="tabela_versaos.index"
                  optionsData="id_tabela_versao"
                  :optionsParm="{ id_operadora: id_operadora }"
                  :optionsReload="true"
                  label="Tabela"
                  required
                  :validate="validate"
                  v-model="item.id_tabela_versao"
                />
              </div>

              <div class="col col-12 col-md-3" v-if="tem_percentual">
                <az-input
                  type="money"
                  label="Percentual de Ajuste"
                  :validate="validate"
                  v-model="item.dc_percentual"
                />
              </div>
            </div>

            <div class="alert alert-info small py-2 mt-2" v-if="tem_percentual && item.dc_percentual">
                <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
                Percentual de ajuste a ser aplicado nos valores da tabela. Exemplo: 10 para aumentarr 10%, -10 para reduzir 10%.
            </div>

            <template v-if="!id_plano">
              <template v-if="item.id_plano || item.id_classe_procedimento || item.id_procedimento">
                <az-sub-title class="mt-3" title="Escopo" />
                <div class="row">
                  <div class="col col-12 col-md-4">
                    <az-input
                      type="select"
                      optionsMode="aql"
                      :optionsSync="false"
                      service="planos.index"
                      :name="'planos.' + item.id_operadora"
                      optionsData="id_plano"
                      :optionsParm="{ where: { id_operadora: item.id_operadora } }"
                      label="Plano"
                      v-model="item.id_plano"
                    />
                  </div>
                  <div class="col col-12 col-md-4" v-if="tipoTabela == 'PRO'">
                    <az-input
                      label="Classificação"
                      service="classe_procedimentos.index"
                      type="select"
                      optionsMode="aql"
                      :optionsSync="false"
                      optionsData="id_classe_procedimento"
                      optionsDisplay="search"
                      :validate="validate"
                      :edicao="!item.id_procedimento"
                      v-model="item.id_classe_procedimento"
                    />
                  </div>
                  <div class="col col-12 col-md-4" v-if="tipoTabela == 'PRO'">
                    <az-input
                      label="Procedimento"
                      :validate="validate"
                      type="autocomplete"
                      service="procedimentos.index"
                      optionsData="id_procedimento"
                      optionsDisplay="search"
                      :optionsInitial="item.procedimento ? item.procedimento.search : ''"
                      :edicao="!item.id_classe_procedimento"
                      v-model="item.id_procedimento"
                    />
                  </div>
                </div>
              </template>
            </template>

            <!-- Filtros -->
            <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
          </div>
          <div class="modal-footer">
            <az-submit
              color="outline-danger"
              @click="remover ()"
              v-if="item.id_tabela_operadora"
            >Remover</az-submit>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizar ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="cotacaoMoedaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Cotação de Moeda
              <span v-if="tabela">
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ tabela.search }}
              </span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  type="date"
                  icon="far fa-calendar-alt"
                  buttonToolTip="Cotação em"
                  v-model="referencia_cotacao" />
              </div>
              <div class="col col-12 col-md-6">
                <az-input
                  :type="abrindo_cotacao ? 'number': 'money'"
                  :precision="4"
                  icon="prepend"
                  :edicao="ajuste_cotacao != 'edit' && ajuste_cotacao != 'copy'"
                  :iconEnd="{ icon: 'fas fa-percent' }"
                  v-model="percentual_cotacao">
                  <template slot="prepend">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                      <i class="fas fa-plus fa-fw" v-if="ajuste_cotacao == 'plus'"></i>
                      <i class="fa fa-minus fa-fw" v-else-if="ajuste_cotacao == 'minus'"></i>
                      <i class="fas fa-edit fa-fw" v-else-if="ajuste_cotacao == 'edit'"></i>
                      <i class="fas fa-copy fa-fw" v-else-if="ajuste_cotacao == 'copy'"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" @click.prevent="ajuste_cotacao = 'plus'">
                        <i class="fas fa-plus fa-fw mr-2"></i>Aumentar
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="ajuste_cotacao = 'minus'">
                        <i class="fa fa-minus fa-fw mr-2" aria-hidden="true"></i>Reduzir
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="ajuste_cotacao = 'edit'">
                        <i class="fas fa-edit fa-fw mr-2" aria-hidden="true"></i>Editar
                      </a>
                      <a class="dropdown-item" href="#" @click.prevent="ajuste_cotacao = 'copy'">
                        <i class="fas fa-copy fa-fw mr-2" aria-hidden="true"></i>Copiar de
                      </a>
                    </div>
                  </template>
                </az-input>
              </div>
            </div>

            <div class="close" v-if="moedas && moedas.filter(item => item.aplicar).length > 0">
              {{ moedas.filter(item => item.aplicar).length }}
              <small class="text-muted">
                {{ moedas.filter(item => item.aplicar).length > 1 ? 'Selecionados' : 'Selecionado' }}
              </small>
            </div>
          </div>
          <div class="modal-body">

            <div class="mb-3" v-if="ajuste_cotacao == 'copy'">
              <div class="row">
                <div class="col col-12 col-md-6">
                  <az-input 
                    placeholder="Operadora..."
                    type="select"
                    optionsMode="aql"
                    optionsData="id_operadora"
                    optionsDisplay="st_operadora"
                    service="operadoras.index"
                    v-model="ajuste.id_operadora" />
                </div>

                <div class="col col-12 col-md-6" v-if="ajuste.id_operadora">
                  <az-input 
                    placeholder="Tabela..."
                    type="autocomplete"
                    :optionsParm="{ id_operadora: ajuste.id_operadora }"
                    :optionsSync="true"
                    optionsMode="aql"
                    optionsDisplay="search"
                    service="tabela_operadoras.index"
                    v-model="ajuste.tabela_operadora" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col col-12">
                <az-input 
                  icon="fa fa-search fa-fw"
                  placecholder="Pesquisar..." 
                  v-model="search_cotacao" />
              </div>
            </div>

            <az-empty-state msg="Nenhuma moeda identificada." v-if="!moedas" />

            <div v-if="moedas">

              <table class="table table-striped table-hover table-sm mb-3">
                <thead>
                  <tr>
                    <th>Moeda</th>
                    <th>De</th>
                    <th>Até</th>
                    <th class="text-right">Valor</th>
                    <th class="text-right" v-if="exibir_aplicar">Novo Valor</th>
                    <th class="text-right" v-if="exibir_aplicar">
                      <input type="checkbox" class="ml-2" :checked="marcar_todos" @click="toggle_aplicar_todos()">
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(moeda, icx) in lista_moedas" :key="icx" :class="moeda.aplicar ? '' : 'text-muted'">
                    <td>{{ moeda.st_moeda }}</td>
                    <td>{{ moeda.cotacao ? $util.getFormatDate(moeda.cotacao.dt_vigencia_inicio) : '' }}</td>
                    <td>
                      <i class="fas fa-infinity" v-if="moeda.cotacao && moeda.cotacao.dt_vigencia_termino == '2100-01-01'"></i>
                      <span v-else>
                        {{ moeda.cotacao ? $util.getFormatDate(moeda.cotacao.dt_vigencia_termino) : '' }}
                      </span>
                    </td>
                    <td class="text-right">{{ $util.formatMoeda(moeda.cotacao ? moeda.cotacao.dc_valor : moeda.dc_valor, 6) }}</td>
                    <td class="float-right" v-if="percentual_cotacao || ajuste_cotacao == 'edit' || ajuste_cotacao == 'copy'">
                      <template v-if="ajuste_cotacao == 'edit' && moeda.aplicar">
                        <az-input
                          style="max-width: 120px;"
                          type="money"
                          sizing="sm" 
                          :precision="6"
                          required 
                          :validate="validate"
                          v-model="moeda.novo_valor" />
                      </template>
                      <span v-if="ajuste_cotacao != 'edit'">
                        {{ $util.formatMoeda(calc_valor_ajuste(moeda)) }}
                      </span>
                    </td>
                    <td class="text-right" v-if="percentual_cotacao || ajuste_cotacao == 'edit' || ajuste_cotacao == 'copy'">
                      <input type="checkbox" class="ml-2" v-model="moeda.aplicar">
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="alert alert-secondary">
                <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
                Cotações das moedas para essa operadora. Sem impacto para outras operadoras.
              </div>

            </div>

          </div>

          <div class="modal-footer">
            <az-audit-log-button model="tabelaOperadora" :id="tabela.id_tabela_operadora" v-if="tabela" />
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit v-if="exibir_aplicar && moeda_selecionada" @click="atualizar_cotacao()">Atualizar</az-submit>
          </div>

        </div>
      </div>
    </div>

    <pre v-if="1 == 0">{{ dados }}</pre>
  </div>
</template>

<script>
import $ from "jquery";
import _ from 'lodash';
import draggable from "vuedraggable";

import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import AzSubTitle from "../../../util/AzSubTitle.vue";
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import OrdenacaoDragnDrop from '../../shared/OrdenacaoDragnDrop.vue';

import FiltroModel from '../../shared/FiltroModel.vue';

export default {
  data() {
    return {
      dados: null,
      search: "",
      item: null,
      tipoTabela: "PRO",
      validate: false,
      cotacoes: [],
      moedas: [],
      incluindo_cotacao: null,
      tabela: null,
      referencia_cotacao: this.$util.hoje(),
      search_cotacao: "", 
      percentual_cotacao: "", 
      ajuste_cotacao: "plus",
      viewMode: "A",
      pode_ordenar: false, 
      abrindo_cotacao: false, 
      pesquisa_moeda: "", 
      ajuste: { 
        id_operadora: "", 
        tabela_operadora: "", 
      }
    };
  },

  components: {
    AzBreakTitle,
    AzInput,
    AzSubmit,
    AzSubTitle,
    draggable,
    AzAuditLogButton,
    AzEmptyState,
    OrdenacaoDragnDrop,
    FiltroModel
  },

  props: ["id_operadora", "id_plano"],

  computed: {
    tem_percentual: function () { 
        if ( !this.item || !this.item.tabela_versao ) { 
            return false; 
        }

        if ( ( this.item.id_tabela_versao == this.item.tabela_versao.id_tabela_versao ) && ( this.item.tabela_versao.st_aplicacao == 'MIX' ) ) { 
            return true;
        }

        return false; 
    },
    
    lista: {
      get() {
        let pesquisar = this.search.trim();
        let parts = pesquisar.replace(" ", ".*");
        let match = parts;
        let reg = new RegExp(match, "i");

        return this.dados && this.dados.length
          ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
            .filter(item => {
              return !this.search || reg.test(JSON.stringify(item));
            })
          : null;
      },
      set(newLista) {
        this.dados = newLista;
      },

    },

    exibir_aplicar: function () { 
      return this.percentual_cotacao || this.ajuste_cotacao == 'edit' || this.ajuste_cotacao == 'copy';
    },

    moeda_selecionada: function () { 
      return this.lista_moedas.findIndex(item => item.aplicar) >= 0; 
    },

    marcar_todos: function() { 
      return this.lista_moedas.findIndex(item => !item.aplicar) < 0;
    },

    lista_moedas: function() { 
      return _.orderBy(
        this.moedas.filter(item => !this.search_cotacao || item.st_moeda.toUpperCase().indexOf(this.search_cotacao.toUpperCase()) >= 0)
          .map(moeda => { 
          let vigente = this.cotacoes.find(cotacao => { 
            return cotacao.id_moeda == moeda.id_moeda && 
              cotacao.dt_vigencia_inicio <= this.referencia_cotacao && 
              cotacao.dt_vigencia_termino >= this.referencia_cotacao; 
          });

          moeda.cotacao = vigente;

          return moeda;
        }), ['ordem', 'st_moeda'], ['asc', 'asc']);
    },

    lista_opcoes_filtro: function () { 
      let opcoes = [                        
        {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
        {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
        {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
        {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
        {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
        {id:'App\\azure\\tipoAtendimento', search:'Tipo de Atendimento', service: 'tipo_atendimentos.index'},
      ];

      if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
        opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'});
        opcoes.push({id:'tag-unidade', search:'Classificação da Unidade', service: 'unidade_operacaos.index', tag: true});
      }

      if ( this.tem_percentual ) { 
        opcoes.push({id:'tag-material', search:'Classificação do Material', service: 'materiais.index', parms: { ativos: true }, tag: true});
        opcoes.push({id:'tag-medicamento', search:'Classificação do Medicamento', service: 'medicamentos.index', parms: { ativos: true }, tag: true});
      }

      return _.orderBy(opcoes, 'search');
    }
    
  },

  methods: {
    ver_precos () { 
      this.$router.push({ 
        name: 'c-valid-precos-operadora', 
        params: { 
          id_operadora: this.id_operadora,
          id_plano: this.id_plano,  
        } 
      });
    },

    toggle_aplicar_todos() { 
      let aplicar = !this.marcar_todos;

      this.lista_moedas.forEach(item => {
        item.aplicar = aplicar;
      });
    },

    calc_valor_ajuste(moeda) { 
      if ( this.ajuste_cotacao == 'copy' ) { 
        this.percentual_cotacao = 0;

        if ( this.ajuste && this.ajuste.id_operadora && this.ajuste.tabela_operadora ) { 
          let cotacao = this.ajuste.tabela_operadora.cotacao_moedas.find(item => 
              item.moeda.st_moeda == moeda.st_moeda
              && item.dt_vigencia_inicio <= this.$util.hoje() 
              && item.dt_vigencia_termino >= this.$util.hoje() 
            );

          if ( cotacao ) { 
            return cotacao.dc_valor;
          }
        }
      }

      return Math.round( 
        100 * ( moeda.cotacao ? moeda.cotacao.dc_valor : moeda.dc_valor ) * 
          (
            ( 
              ( this.percentual_cotacao / 100 ) * ( this.ajuste_cotacao == 'minus' ? -1 : 1 ) 
            ) + 1
          )
      ) / 100;
    },

    remover_cotacao(cotacao, idx) { 
      $('[data-toggle="tooltip"]').tooltip('dispose');

      if ( !confirm('Confirma remover essa cotação?') )
        return;

      this.$util.remover (this, { 
        service: 'cotacao_moedas', 
        dados: cotacao,
        callback: () => { 
          this.cotacoes.splice(idx, 1);
        }
      });
    },

    atualizar_cotacao () { 
      $('[data-toggle="tooltip"]').tooltip('dispose');

      if ( !this.referencia_cotacao ) { 
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Informar a data da cotação.",
          life: 3000
        });
        return;
      }

      let dados = this.lista_moedas.filter(item => item.aplicar)
        .map(item => {  
          item.inicio = this.referencia_cotacao;

          if ( this.ajuste_cotacao != 'edit' ) { 
            item.novo_valor = this.calc_valor_ajuste(item);
          }

          return item;
        });

      this.$util.atualizar (this, { 
        service: 'cotacao_moedas', 
        func: 'atualizar_cotacao',
        dados: dados,
        modal: "cotacaoMoedaModal",
        reload: true, 
      });
    },
    
    listar_cotacoes (tabela) { 
      this.$store.commit("loading", true);

      this.abrindo_cotacao = true;
      this.ajuste.id_operadora = "";
      this.ajuste.tabela_operadora = "";

      this.$nextTick(() => { 

        this.validate = false;
        this.tabela = tabela;
        this.moedas = null;
        this.incluindo_cotacao = null;
        this.cotacoes = tabela.cotacao_moedas;
        this.percentual_cotacao = 0;
        this.ajuste_cotacao = 'plus';
  
        $('#cotacaoMoedaModal').modal('show');
  
        this.$util.loadItem(this, { 
          service: 'moedas', 
          func: 'index',
          parms: { 
            id_tabela_operadora: tabela.id_tabela_operadora,
          }
        })
        .then(res => { 
          if ( res.findIndex(item => item.st_moeda == 'UCO') < 0 ) { 
            res.unshift({ id_moeda: -1, st_moeda: 'UCO', search: 'UCO', dc_valor: tabela.tabela_versao.dc_valor_uco ? tabela.tabela_versao.dc_valor_uco : 0 });
          } else { 
            let uco = res.find(item => item.st_moeda == 'UCO');
            uco.dc_valor = tabela.tabela_versao.dc_valor_uco ? tabela.tabela_versao.dc_valor_uco : 0;
          }

          if ( res.findIndex(item => item.st_moeda == 'FILME') < 0 ) {
            if ( tabela.tabela_versao && tabela.tabela_versao.fl_tem_imagem ) { 
              res.unshift({ id_moeda: -2, st_moeda: 'FILME', search: 'FILME', dc_valor: tabela.tabela_versao.dc_valor_filme ? tabela.tabela_versao.dc_valor_filme : 0 });
            }
          } else { 
            let filme = res.find(item => item.st_moeda == 'FILME');
            filme.dc_valor = tabela.tabela_versao.dc_valor_filme ? tabela.tabela_versao.dc_valor_filme : 0;
          }

          this.moedas = res.map(item => { 
            item.aplicar = false;
            item.novo_valor = "";
            item.id_tabela_operadora = tabela.id_tabela_operadora;
            return item;
          });

        })
        .finally(() => { 
          this.$store.commit("loading", false);
          this.abrindo_cotacao = false;
        });

      });

    },

    atualizarOrdem () { 
  
      this.$util.atualizar(this, { 
        service: 'tabela_operadoras', 
        func: 'ordem',
        dados: {
          lista: this.lista
        },
        toast: true, 
      });

    },

    incluir() {
      this.editar({
        id_tabela_operadora: null,
        id_operadora: this.id_operadora,
        id_codigo_tabela: null,
        id_tabela_versao: null,
        id_plano: this.id_plano,
        id_classe_procedimento: null,
        id_procedimento: null,
        fl_ativo: true,
        fl_excecao: false,
        st_aplicacao: "PRO",
        filtros: [], 
      });
    },

    toggle(item) {
      this.$util.toggle(this, { 
        service: 'tabela_operadoras',
        dados: item, 
      });
    },

    editar(item) {
        this.item = null; 

        this.$nextTick(() => {
            this.item = { ...item };
            this.validate = false;
            $("#tabelaModal").modal("show");
        });
    },

    remover() {
      this.$util.remover(this, {
        service: "tabela_operadoras",
        dados: this.item,
        modal: "tabelaModal",
        reload: true
      });
    },

    atualizar() {
      this.$util.atualizar(this, {
        service: "tabela_operadoras",
        dados: this.item,
        modal: "tabelaModal",
        reload: true
      });
    },

    load() {
      this.$util.load(this, {
        service: "tabela_operadoras",
        parms: {
          where: {
            id_operadora: this.id_operadora,
            id_plano: this.id_plano, 
          }
        }
      });

    }
  },

  mounted() {
    this.load();
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>